import {Module} from "vuex";

import {RootStateType} from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import {ProcessProfileState} from "./model";

let state: ProcessProfileState = {
  processProfiles: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ProcessProfileState, RootStateType>;
